<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-card>
      <v-row justify="center">
        <v-col sm="3">
          <h3>Join Group</h3>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col sm="3">
          <v-text-field label="Group Code" v-model="group_code" hint="For example, ABC123, 145XYZ" outlined
            dense></v-text-field>
        </v-col>
        <v-col sm="3">
          <v-btn color="primary darken-1" @click="addMemberUsingCode">Join Group</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <br />
    <v-card class="main">
      <v-data-table :headers="headers" :items="comm_groups_users" class="elevation-1" item-key="id">
        <template v-slot:top>
          <v-toolbar flat color="#ffffcc">
            <v-toolbar-title>Communication Groups </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-card>
        <communication-group v-if="addToGroup==true" :group_code="group_code"></communication-group>
    </v-card> -->
  </div>
</template>
<script>
import axios from "axios";
import JoinGroup from './JoinGroup'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
 data: () => ({
   addToGroup: false,
  //  extraBreadcrumbItems: [


  //  ],
  //  breadcrumbClass: "breadcrumb-style1",
        group_code: " ",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        comm_groups_users:[],
        headers: [
          { text: "Title", value: 'title' },
          { text: "Description", value: 'description' },
          { text: "Groupcode", value: 'groupcode' },
          { text: "Createdby", value: 'createdby' },
        ]
 }),
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad(){
    axios
      .post("/CommunicationGroup/getDataforJoinGroup")
      .then(res => {
        if (res.data.msg == "200") {
          this.comm_groups_users=res.data.comm_groups_users
        }
      })
      .catch(error => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        //stop loader
      });
    },
     showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    addMemberUsingCode() {
      //alert("addMemberUsingCode")
      //alert("group_code:"+this.group_code)
     const formData = {
        group_code: this.group_code
      };
      axios
        .post("/CommunicationGroup/addMemberUsingCode", formData)
        .then(res => {
          console.log(res.data);
          if (res.data.status == "Yes") {
            this.showSnackbar("#4caf50", "Joined Successfully..."); // show snackbar
            this.onLoad();
          } else if (res.data.status == "No") {
            alert("no")
            this.showSnackbar("#b71c1c", "Group Code Doesn't Matched..."); // show snackbar
            //this.onLoad();
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //stop loader
          //   this.tt_load = false;
        });
    }
  }
};
</script>